import * as React from 'react'
import {
  FaIcon,
  faChevronRight,
  faChevronLeft,
  faChevronsLeftSolid,
  faChevronsRightSolid,
} from '@/lib/fa'
import DividerVertical from '@/modules/drivers/shared/DividerVertical'
import ChevronsTripleLeft from '@/assets/icons_new/ChervronsTripleLeft.svg'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import Tooltip from '@/modules/drivers/shared/ToolTip'

const CompareNavigation = ({
  goToDate,
}: {
  goToDate: (days: number) => void
}) => {
  const { t } = useLocalize()

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-mb-3  tw-bg-white tw-px-5 tw-py-3">
        <p className="tw-text-sm tw-font-medium">Widok dzienny</p>

      <div className="tw-flex tw-items-center tw-gap-2">
        <Tooltip text={t('compareNavigation.previousThreeDays')} asChild>
          <button onClick={() => goToDate(-3)}>
            <img src={ChevronsTripleLeft} />
          </button>
        </Tooltip>
        <DividerVertical />
        <Tooltip text={t('compareNavigation.previousTwoDays')} asChild>
          <button onClick={() => goToDate(-2)}>
            <FaIcon icon={faChevronsLeftSolid} />
          </button>
        </Tooltip>
        <DividerVertical />
        <Tooltip text={t('compareNavigation.previousDay')} asChild>
          <button onClick={() => goToDate(-1)}>
            <FaIcon icon={faChevronLeft} />
          </button>
        </Tooltip>
        <DividerVertical />
        <Tooltip text={t('compareNavigation.nextDay')} asChild>
          <button onClick={() => goToDate(1)}>
            <FaIcon icon={faChevronRight} />
          </button>
        </Tooltip>
        <DividerVertical />
        <Tooltip text={t('compareNavigation.nextTwoDays')} asChild>
          <button onClick={() => goToDate(2)}>
            <FaIcon icon={faChevronsRightSolid} />
          </button>
        </Tooltip>
        <DividerVertical />
        <Tooltip text={t('compareNavigation.nextThreeDays')} asChild>
          <button onClick={() => goToDate(3)}>
            <img src={ChevronsTripleLeft} className="tw-rotate-180" />
          </button>
        </Tooltip>
      </div>
    </div>
  )
}

export default CompareNavigation
